module.exports = __webpack_public_path__ + "static/media/image-3@3x.eaf6983b.png";